import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { SearchInput } from '../../components/ui/Input';
import { Building2, Users, MoreHorizontal, Plus, Edit2, Trash2, Eye, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const projects = [{
  id: 1,
  name: 'The Riverside Collection',
  builder: 'Excel Homes',
  builderId: 1,
  status: 'Active',
  buyers: 124,
  lastActivity: '2 hours ago'
}, {
  id: 2,
  name: 'Coastal Living',
  builder: 'Schell Brothers',
  builderId: 2,
  status: 'Active',
  buyers: 234,
  lastActivity: '1 hour ago'
}, {
  id: 3,
  name: 'Summit Ridge',
  builder: 'Mattamy Homes',
  builderId: 3,
  status: 'Active',
  buyers: 312,
  lastActivity: '30 mins ago'
}, {
  id: 4,
  name: 'Pioneer Square',
  builder: 'Landmark Homes',
  builderId: 4,
  status: 'Active',
  buyers: 45,
  lastActivity: '1 day ago'
}, {
  id: 5,
  name: 'Horizon Heights',
  builder: 'Starward Homes',
  builderId: 5,
  status: 'Active',
  buyers: 156,
  lastActivity: '3 hours ago'
}, {
  id: 6,
  name: 'Oakwood Estates',
  builder: 'Excel Homes',
  builderId: 1,
  status: 'Active',
  buyers: 89,
  lastActivity: '1 day ago'
}, {
  id: 7,
  name: 'Test Project',
  builder: 'Rohit',
  builderId: 6,
  status: 'Draft',
  buyers: 12,
  lastActivity: '2 weeks ago'
}];
const builders = [{
  id: 1,
  name: 'Excel Homes'
}, {
  id: 2,
  name: 'Schell Brothers'
}, {
  id: 3,
  name: 'Mattamy Homes'
}, {
  id: 4,
  name: 'Landmark Homes'
}, {
  id: 5,
  name: 'Starward Homes'
}, {
  id: 6,
  name: 'Rohit'
}];
export function AdminProjectsPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const [newProject, setNewProject] = useState({
    name: '',
    builderId: ''
  });
  const [renameValue, setRenameValue] = useState('');
  const filteredProjects = projects.filter(project => project.name.toLowerCase().includes(searchQuery.toLowerCase()) || project.builder.toLowerCase().includes(searchQuery.toLowerCase()));
  // ESC key handler
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (showCreateModal) setShowCreateModal(false);
        if (showReassignModal) setShowReassignModal(false);
        if (showRenameModal) setShowRenameModal(false);
        if (showDeleteModal) setShowDeleteModal(false);
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [showCreateModal, showReassignModal, showRenameModal, showDeleteModal]);
  const handleCreateProject = () => {
    console.log('Creating project:', newProject);
    setShowCreateModal(false);
    setNewProject({
      name: '',
      builderId: ''
    });
  };
  const handleReassignProject = (builderId: string) => {
    console.log('Reassigning project:', selectedProject.id, 'to builder:', builderId);
    setShowReassignModal(false);
    setSelectedProject(null);
  };
  const handleRenameProject = () => {
    console.log('Renaming project:', selectedProject.id, 'to:', renameValue);
    setShowRenameModal(false);
    setSelectedProject(null);
    setRenameValue('');
  };
  const handleDeleteProject = () => {
    console.log('Deleting project:', selectedProject.id);
    setShowDeleteModal(false);
    setSelectedProject(null);
  };
  const openMenu = (projectId: number) => {
    setOpenMenuId(openMenuId === projectId ? null : projectId);
  };
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = () => setOpenMenuId(null);
    if (openMenuId) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [openMenuId]);
  return <>
      <div className="space-y-6 max-w-7xl mx-auto" data-id="element-250">
        <div className="flex items-center justify-between" data-id="element-251">
          <div data-id="element-252">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-253">All Projects</h1>
            <p className="text-slate-500" data-id="element-254">
              View and manage projects across all builders
            </p>
          </div>
          <Button leftIcon={<Plus className="h-4 w-4" data-id="element-256" />} onClick={() => setShowCreateModal(true)} data-id="element-255">
            Create Project
          </Button>
        </div>

        <Card noPadding data-id="element-257">
          <div className="p-4 border-b border-slate-200 flex items-center justify-between bg-slate-50 rounded-t-xl" data-id="element-258">
            <SearchInput className="max-w-sm bg-white" placeholder="Search projects or builders..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-259" />
            <div className="flex gap-2" data-id="element-260">
              <Button variant="outline" size="sm" data-id="element-261">
                Filter
              </Button>
              <Button variant="outline" size="sm" data-id="element-262">
                Export
              </Button>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-263">
            <table className="w-full text-left text-sm" data-id="element-264">
              <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-265">
                <tr data-id="element-266">
                  <th className="px-6 py-4" data-id="element-267">Project Name</th>
                  <th className="px-6 py-4" data-id="element-268">Builder</th>
                  <th className="px-6 py-4" data-id="element-269">Status</th>
                  <th className="px-6 py-4" data-id="element-270">Buyers</th>
                  <th className="px-6 py-4" data-id="element-271">Last Activity</th>
                  <th className="px-6 py-4 text-right" data-id="element-272">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-273">
                {filteredProjects.length === 0 ? <tr data-id="element-274">
                    <td colSpan={6} className="px-6 py-12 text-center text-slate-500" data-id="element-275">
                      No projects found matching "{searchQuery}"
                    </td>
                  </tr> : filteredProjects.map(project => <tr key={project.id} className="hover:bg-slate-50 transition-colors" data-id="element-276">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-277">
                        {project.name}
                      </td>
                      <td className="px-6 py-4" data-id="element-278">
                        <div className="flex items-center gap-2" data-id="element-279">
                          <Building2 className="h-4 w-4 text-slate-400" data-id="element-280" />
                          <span className="text-slate-600" data-id="element-281">
                            {project.builder}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4" data-id="element-282">
                        <Badge variant={project.status === 'Active' ? 'success' : 'neutral'} data-id="element-283">
                          {project.status}
                        </Badge>
                      </td>
                      <td className="px-6 py-4" data-id="element-284">
                        <div className="flex items-center gap-1 text-slate-600" data-id="element-285">
                          <Users className="h-4 w-4 text-slate-400" data-id="element-286" />
                          {project.buyers}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-287">
                        {project.lastActivity}
                      </td>
                      <td className="px-6 py-4 text-right" data-id="element-288">
                        <div className="flex items-center justify-end gap-2" data-id="element-289">
                          <Button variant="ghost" size="sm" onClick={() => {
                      setSelectedProject(project);
                      setShowReassignModal(true);
                    }} data-id="element-290">
                            Reassign
                          </Button>
                          <Button variant="ghost" size="sm" onClick={() => navigate(`/admin/projects/${project.id}`)} data-id="element-291">
                            View Details
                          </Button>
                          <div className="relative" data-id="element-292">
                            <Button variant="ghost" size="sm" onClick={e => {
                        e.stopPropagation();
                        openMenu(project.id);
                      }} data-id="element-293">
                              <MoreHorizontal className="h-4 w-4" data-id="element-294" />
                            </Button>

                            {/* Dropdown Menu */}
                            {openMenuId === project.id && <div className="absolute right-0 mt-1 w-48 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50" data-id="element-295">
                                <button onClick={e => {
                          e.stopPropagation();
                          setSelectedProject(project);
                          setRenameValue(project.name);
                          setShowRenameModal(true);
                          setOpenMenuId(null);
                        }} className="flex items-center gap-3 w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-296">
                                  <Edit2 className="h-4 w-4 text-slate-400" data-id="element-297" />
                                  Rename Project
                                </button>
                                <button onClick={e => {
                          e.stopPropagation();
                          setSelectedProject(project);
                          setShowDeleteModal(true);
                          setOpenMenuId(null);
                        }} className="flex items-center gap-3 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors" data-id="element-298">
                                  <Trash2 className="h-4 w-4" data-id="element-299" />
                                  Delete Project
                                </button>
                              </div>}
                          </div>
                        </div>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Create Project Modal */}
      {showCreateModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-300">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-301">
            <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-302">
              <div data-id="element-303">
                <h2 className="text-xl font-bold text-slate-900" data-id="element-304">
                  Create New Project
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-305">
                  Create a project and assign it to a builder
                </p>
              </div>
              <button onClick={() => setShowCreateModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-306">
                <X className="h-5 w-5" data-id="element-307" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-308">
              <div data-id="element-309">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-310">
                  Project Name
                </label>
                <input type="text" value={newProject.name} onChange={e => setNewProject({
              ...newProject,
              name: e.target.value
            })} placeholder="e.g., The Riverside Collection" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:ring-primary-500 focus:border-primary-500" autoFocus data-id="element-311" />
              </div>
              <div data-id="element-312">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-313">
                  Assign to Builder
                </label>
                <select value={newProject.builderId} onChange={e => setNewProject({
              ...newProject,
              builderId: e.target.value
            })} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-314">
                  <option value="" data-id="element-315">Select a builder...</option>
                  {builders.map(builder => <option key={builder.id} value={builder.id} data-id="element-316">
                      {builder.name}
                    </option>)}
                </select>
              </div>
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-317">
              <Button variant="outline" onClick={() => setShowCreateModal(false)} data-id="element-318">
                Cancel
              </Button>
              <Button onClick={handleCreateProject} disabled={!newProject.name || !newProject.builderId} data-id="element-319">
                Create Project
              </Button>
            </div>
          </div>
        </div>}

      {/* Reassign Project Modal */}
      {showReassignModal && selectedProject && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-320">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-321">
            <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-322">
              <div data-id="element-323">
                <h2 className="text-xl font-bold text-slate-900" data-id="element-324">
                  Reassign Project
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-325">
                  Reassign "{selectedProject.name}" to a different builder
                </p>
              </div>
              <button onClick={() => setShowReassignModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-326">
                <X className="h-5 w-5" data-id="element-327" />
              </button>
            </div>
            <div className="p-6" data-id="element-328">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-329">
                New Builder
              </label>
              <select defaultValue={selectedProject.builderId} onChange={e => handleReassignProject(e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-330">
                {builders.map(builder => <option key={builder.id} value={builder.id} data-id="element-331">
                    {builder.name}
                  </option>)}
              </select>
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-332">
              <Button variant="outline" onClick={() => setShowReassignModal(false)} data-id="element-333">
                Cancel
              </Button>
            </div>
          </div>
        </div>}

      {/* Rename Project Modal */}
      {showRenameModal && selectedProject && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-334">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-335">
            <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-336">
              <div data-id="element-337">
                <h2 className="text-xl font-bold text-slate-900" data-id="element-338">
                  Rename Project
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-339">
                  Change the name of "{selectedProject.name}"
                </p>
              </div>
              <button onClick={() => setShowRenameModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-340">
                <X className="h-5 w-5" data-id="element-341" />
              </button>
            </div>
            <div className="p-6" data-id="element-342">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-343">
                New Project Name
              </label>
              <input type="text" value={renameValue} onChange={e => setRenameValue(e.target.value)} placeholder="Enter new project name" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:ring-primary-500 focus:border-primary-500" autoFocus data-id="element-344" />
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-345">
              <Button variant="outline" onClick={() => setShowRenameModal(false)} data-id="element-346">
                Cancel
              </Button>
              <Button onClick={handleRenameProject} disabled={!renameValue.trim()} data-id="element-347">
                Rename
              </Button>
            </div>
          </div>
        </div>}

      {/* Delete Project Modal */}
      {showDeleteModal && selectedProject && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-348">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-349">
            <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-350">
              <div data-id="element-351">
                <h2 className="text-xl font-bold text-slate-900" data-id="element-352">
                  Delete Project
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-353">
                  Are you sure you want to delete "{selectedProject.name}"?
                </p>
              </div>
              <button onClick={() => setShowDeleteModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-354">
                <X className="h-5 w-5" data-id="element-355" />
              </button>
            </div>
            <div className="p-6" data-id="element-356">
              <div className="bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-357">
                <p className="text-sm text-red-800" data-id="element-358">
                  <strong data-id="element-359">Warning:</strong> This action cannot be undone. All
                  project data, including {selectedProject.buyers} buyer
                  records, will be permanently deleted.
                </p>
              </div>
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-360">
              <Button variant="outline" onClick={() => setShowDeleteModal(false)} data-id="element-361">
                Cancel
              </Button>
              <Button onClick={handleDeleteProject} className="!bg-red-600 hover:!bg-red-700 !text-white" data-id="element-362">
                Delete Project
              </Button>
            </div>
          </div>
        </div>}
    </>;
}